// extracted by mini-css-extract-plugin
export default {"screener":"screener_screener__kyNnF","dialog":"screener_dialog__xJa2K"};